import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import { useTheme } from "@mui/material/styles";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const TREND_COLOR = {
  up: "success",
  down: "error",
  neutral: "text",
};

function StatCard({ color, icon, label, value, trendLabel, trendTone }) {
  const { palette } = useTheme();
  const badge = palette.badgeColors[color] || palette.badgeColors.dark;

  return (
    <Card
      sx={({ boxShadows }) => ({
        height: "100%",
        border: "1px solid",
        borderColor: "grey.200",
        boxShadow: boxShadows.sm,
      })}
    >
      <MDBox p={1.75}>
        <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={1}>
          <MDTypography
            variant="button"
            color="text"
            fontWeight="medium"
            sx={{ fontSize: "0.75rem" }}
          >
            {label}
          </MDTypography>
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="1.875rem"
            height="1.875rem"
            borderRadius="md"
            sx={{ backgroundColor: badge.background, color: badge.text, flexShrink: 0 }}
          >
            <Icon fontSize="small">{icon}</Icon>
          </MDBox>
        </MDBox>

        <MDTypography variant="h5" fontWeight="bold">
          {value}
        </MDTypography>

        {trendLabel && (
          <MDTypography
            variant="caption"
            fontWeight="bold"
            color={TREND_COLOR[trendTone]}
            display="block"
            mt={0.5}
          >
            {trendLabel}
          </MDTypography>
        )}
      </MDBox>
    </Card>
  );
}

StatCard.defaultProps = {
  color: "dark",
  trendLabel: undefined,
  trendTone: "neutral",
};

StatCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  icon: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]).isRequired,
  trendLabel: PropTypes.string,
  trendTone: PropTypes.oneOf(["up", "down", "neutral"]),
};

export default StatCard;
